import { create } from 'apisauce';
import { isMobile, isTablet, osName, osVersion, browserName, mobileVendor, mobileModel } from 'react-device-detect';

export const DEVICE_CHANGE = 'Your session has expire or you have log in on another device please logout and login again';

export const api = create({
    baseURL: process.env.REACT_APP_API_BASE_URL
});

const getDeviceHeaders = () => {
    try {
        let deviceId = localStorage.getItem('web_device_id');
        if (!deviceId) {
            deviceId = 'web_' + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            localStorage.setItem('web_device_id', deviceId);
        }

        return {
            'X-Device-Id': deviceId,
            'X-Device-OS': osName || 'Web',
            'X-Device-OS-Version': osVersion || 'unknown',
            'X-Device-Model': isMobile ? mobileModel || 'Mobile Browser' : browserName || 'Web Browser',
            'X-Device-Brand': isMobile ? mobileVendor || 'Web' : 'Web',
            'X-Device-Type': isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop',
            'X-App-Version': '3.2.0'
        };
    } catch (error) {
        console.error('Error getting device info for headers:', error);
        return {};
    }
};

api.addRequestTransform((request) => {
    const deviceHeaders = getDeviceHeaders();
    Object.keys(deviceHeaders).forEach((key) => {
        request.headers[key] = deviceHeaders[key];
    });
});

// logout user if status code is 401 or 409 (device change)
api.addMonitor((response) => {
    if (response.status === 401 && response.config.url !== '/login') {
        localStorage.clear();
        window.location.href = '/login';
    }

    if (response.status === 409 && response?.data?.message === DEVICE_CHANGE) {
        localStorage.clear();
        window.location.href = '/login';
    }
});
